import { DataBean } from "../DataBean";

export class Countries extends DataBean {
  public async gerStatesCitiesRender(
    page: number,
    rows: number,
    props: any
  ): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.shared.Report_gerStatesCitiesRender_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async getStatesCatalogPorPropiedades(
    properties: any,
    maxRows: number | null
  ): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "java.util.List_getStatesCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async gerCountryRender(
    page: number,
    rows: number,
    props: any
  ): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.shared.Report_gerCountryRender_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async getCountrieByID(idCountrie: number): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.cache.bean.Countries_getCountries_Number",
      [idCountrie]
    );
  }

  public async getCitiesByID(idCities: number): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.cache.bean.Cities_getCities_Number",
      [idCities]
    );
  }
}
